import React from "react";
import Link from "@mui/material/Link";
import { getClassName } from "@sscs/utils";
import { ExternalLinkIcon } from "../../icons";
import styles from "./externalLink.module.scss";
const ExternalLink = ({ href, className, children, }) => {
    return (React.createElement(Link, { href: href, target: "_blank", className: getClassName(styles.link, className) },
        React.createElement(ExternalLinkIcon, { size: "inherit" }),
        children));
};
export default ExternalLink;
//# sourceMappingURL=ExternalLink.js.map